/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Heading, Box } from 'sarsaparilla';
import Overview from './Overview';
import { ContentProps } from '../props/contents';

function PassSelectionPanel({ title = '', overview = [] }) {
    return (
        <Box className="pass-selection-panel" border="gray">
            <Box className="pass-selection-panel__header">
                <Heading headingLevel={2} appearance="h6">
                    {`About ${title}`}
                </Heading>
            </Box>
            <Box className="pass-selection-panel__content">
                <Overview overview={overview} />
            </Box>
        </Box>
    );
}

PassSelectionPanel.propTypes = {
    title: PropTypes.string,
    overview: PropTypes.arrayOf(ContentProps),
};

export default PassSelectionPanel;
